// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lost {
  display: block;
  width: 80vw;
  margin: 0.5rem auto;
  color: #247a97;
  font-size: 7rem;
  font-weight: 800;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/NotFound.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".lost {\n  display: block;\n  width: 80vw;\n  margin: 0.5rem auto;\n  color: #247a97;\n  font-size: 7rem;\n  font-weight: 800;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
